import React from 'react';
import { NavLink } from 'react-router-dom';

const ITEMS = [
  { to: '/',       label: 'Home',   icon: '🏠' },
  { to: '/invest', label: 'Invest', icon: '💎' },
  { to: '/team',   label: 'Team',   icon: '👥' },
  { to: '/ranks',  label: 'Ranks',  icon: '🏆' }
];

export const BottomNav = () => (
  <nav className="bottom-nav">
    {ITEMS.map((it) => (
      <NavLink
        key={it.to}
        to={it.to}
        end={it.to === '/'}
        className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
      >
        <span className="bottom-nav-icon">{it.icon}</span>
        <span>{it.label}</span>
      </NavLink>
    ))}
  </nav>
);
